// extracted by mini-css-extract-plugin
export var copyIcon = "_yk-2";
export var discountCard = "_yk-0";
export var discountCode = "_yk-3";
export var discountContent = "_yk-1";
export var loadingCard = "_yk-4";